module.exports = __webpack_public_path__ + "static/media/Corn7R2.dca645bb.png";